export default __webpack_public_path__ + "static/media/halias-logo.958993d8.png";